import Styles from "./OurStoryNew.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { appLevelConstants } from "../../constants/AppLevelConstants";
import { urls } from "../../utils/urls";

export default function OurStoryNew() {
  const containerRef = useRef(null);
  const [revealed, setRevealed] = useState(() => ({ 0: true }));

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;

    const rows = root.querySelectorAll("[data-journey-index]");
    if (!rows.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const raw = entry.target.getAttribute("data-journey-index");
          const idx = raw == null ? NaN : Number.parseInt(raw, 10);
          if (Number.isNaN(idx)) return;
          setRevealed((prev) => {
            if (prev[idx]) return prev;
            return { ...prev, [idx]: true };
          });
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );

    rows.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className={Styles["main-parent-div"]}>
      <div className={Styles["main-parent-inner-container"]}>
        <section className={Styles["journeyStickyHead"]}>
          <div>
            <span className={Styles["titile"]}>
              {appLevelConstants.aboutUs.ourStoryTitle}
            </span>
          </div>
        </section>
        <div ref={containerRef} className={Styles["our-journy-container"]}>
          {appLevelConstants.aboutUs.ourStories &&
            appLevelConstants.aboutUs.ourStories.map((val, index) => (
              <React.Fragment key={`${val.title}-${index}`}>
                <div
                  className={`${
                    Styles[
                      index === 0
                        ? "stepper-container-left-first"
                        : "stepper-container-left"
                    ]
                  } ${revealed[index] ? Styles["journeyVisible"] : ""}`}
                >
                  {index !== 0 && (
                    <div className={Styles["vertical-line-top"]}></div>
                  )}
                  <div className={Styles["markerWrap"]}>
                    <img
                      src={urls.stepperIcon}
                      alt=""
                      className={Styles["icon"]}
                    />
                  </div>
                  <div className={Styles["vertical-line"]}></div>
                </div>
                <div
                  data-journey-index={index}
                  className={`${
                    Styles[
                      index === 0
                        ? "stepper-container-right-first"
                        : "stepper-container-right"
                    ]
                  } ${revealed[index] ? Styles["journeyVisible"] : ""}`}
                >
                  <span className={Styles["year-title"]}>{val.title}</span>
                  {val.description.map((des) => (
                    <ul
                      key={des.id}
                      className={Styles["year-description-div"]}
                    >
                      <li className={Styles["year-description"]}>
                        {des.value}
                        {des.home ? (
                          <Link className={Styles["year-home"]} to="/">
                            {des.home}
                          </Link>
                        ) : null}
                      </li>
                    </ul>
                  ))}
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  );
}
